<template>
    <div style="position: relative">
        <input class="form-control"
               type="text"
               v-model="search_string"
               @keydown.esc="clearAutoCompleteList()"
               @focus="setActiveInput()"
        >

        <!-- Autocomplete list -->
        <div class="select-product__result-container" v-show="found_products.length > 0">
            <div class="select-product__result__body">
                <ul class="list-group">
                    <li
                            v-for="product in found_products"
                            class="list-group-item select-product__result-item"
                            @click="setActiveProduct(product)"
                    >
                        {{product.name}}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['input_index'],
        data: function () {
            return {
                search_string: '',
                found_products: [],
                active_product: null,
                auto_complete_cache: {},
            };
        },
        methods: {
            setActiveInput: function () {
                this.$root.$emit('select-product-autocomplete:active_input', this.input_index);
            },
            // AUTO COMPLETE
            autoComplete: function (search_string) {
                if (search_string.length < 3) {
                    return;
                }

                if (search_string in this.auto_complete_cache) {
                    this.found_products = this.getFromCache(search_string);
                    return;
                }

                let self = this;
                this.$http
                    .post('/catalog/products/autocomplete', {search_string: search_string})
                    .then(function (response) {
                        self.found_products = response.data.products;
                        self.putToCache(search_string, response.data.products);
                    });
            },
            setActiveProduct: function (product) {
                this.search_string = '';
                this.clearAutoCompleteList();
                this.active_product = product;
                this.$root.$emit('select-product-autocomplete:product_selected', product);
            },
            getFromCache: function (key) {
                return this.auto_complete_cache[key];
            },
            putToCache: function (key, search_result) {
                this.auto_complete_cache[key] = search_result;
            },
            clearAutoCompleteList: function () {
                this.found_products = [];
            },
        },
        watch: {
            'search_string': function (val) {
                this.autoComplete(val);
            },
        },
    }
</script>
